import { SVGProps } from 'react';

const SvgRecruitBadge = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="1em"
    fill={props.fill || '#fff'}
    viewBox="0 0 12 10"
    {...props}
  >
    <path d="M11.312 3.533c-.344-.037-.649-.075-.842-.075-1.452 0-2.712.419-3.744 1.219-.61.493-1.031.99-1.298 1.559-.19.418-.382 1.027-.572 1.824L4.436 10H0L2.063.303h4.435l-.46 2.093C6.805 1.56 7.569.95 8.334.572 9.137.19 10.014 0 11.007 0c.383 0 .726.037.993.075l-.688 3.461v-.003Z" />
  </svg>
);

export default SvgRecruitBadge;
